/** Obtiene la URL de carga de datos de una capa OpenLayers.
 * 
 *
 * Esta función es útil cuando se quiere refrescar una capa y se necesita saber
 * desde qué URL se deben volver a cargar los datos (por ejemplo, para hacer un fetch).
 *
 * Se intenta obtener la URL en este orden:
 * 
 * 1. Desde el `getUrl()` de la fuente de datos (`source.getUrl()`), que es típico en VectorSource.
 * 2. Si la fuente es un `Cluster`, intenta acceder al `source.getSource().getUrl()`.
 * 3. Si no se encuentra ninguna de las anteriores, se busca en las propiedades personalizadas
 *    de la capa (`layer.get('url')`), que puede haber sido añadida manualmente durante la configuración.
 *
 * @param {ol/layer/Vector|ol/layer/VectorTile} layer - La capa OpenLayers de la que se quiere obtener la URL.
 * @returns {string|null} - Devuelve la URL de la fuente de datos, o `null` si no se encuentra.
 */

export const getLayerUrl = (layer) => {
    // Si no es una capa válida o no tiene fuente, no se puede obtener la URL
    if (!layer || typeof layer.getSource !== 'function') return null;
  
    const source = layer.getSource();
  
    // Caso 1: La fuente es un VectorSource y tiene un método getUrl
    if (typeof source.getUrl === 'function') {
      const url = source.getUrl();
      if (url) return url;
    }
  
    // Caso 2: La fuente es un Cluster (source dentro de source)
    if (typeof source.getSource === 'function') {
      const innerSource = source.getSource();
      if (innerSource && typeof innerSource.getUrl === 'function') {
        const innerUrl = innerSource.getUrl();
        if (innerUrl) return innerUrl;
      }
    }
  
    // Caso 3: URL definida manualmente en las propiedades de la capa (por ejemplo, en config.LAYERS o GROUPS)
    if (typeof layer.get === 'function' && layer.get('url')) {
      return layer.get('url');
    }
  
    // Si no se pudo encontrar ninguna URL válida
    return null;
  };
  